/* unplugin-vue-components disabled */import script from "./BlackInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackInput.vue?vue&type=script&setup=true&lang=js"

import "./BlackInput.vue?vue&type=style&index=0&id=c5817e7c&lang=stylus"

const __exports__ = script;

export default __exports__